import React from 'react';
import { connect } from 'react-redux';
import RealNameCom from './components/RealNameCom';

const RiskRealnameContent = ({ visible, onSuccess, onCancel, base }) => {
  const { riskAuthData } = base;
  if (!visible) return null;
  return (
    <RealNameCom
      cert={riskAuthData.cert}
      onCancel={onCancel}
      onSuccess={onSuccess}
    />
  );
};

export default connect((store) => ({ base: store }))(RiskRealnameContent);
